<template>
  <div class="margin-bottom-15">
    <div class="d-flex flex-column align-items-end">
      <div>
        <el-tooltip content="Tải báo cáo" placement="top" :open-delay="500">
          <a target="_blank" @click="handleDownloadReport(info)" :class="isDisable">
            <FAIcon icon="fas fa-chart-pie icon " />
          </a>
        </el-tooltip>
      </div>
    </div>
    <el-dialog :visible.sync="isShowReportDocumentForm" width="50%">
      <div class="title_popup text-center"><FAIcon icon="fas fa-file-download" /> Tải báo cáo</div>
      <el-row>
        <el-col :span="8">
          <div @click="handleDownloadSummaryReport(info.slug)">
            <el-card :body-style="{ padding: '0px' }">
              <img src="@/assets/img/summary_report.jpg" class="image padding-left-15 padding-right-15" />
              <div class="report_download_button">
                <el-button type="primary" round><FAIcon icon="fas fa-file-download" /> Báo cáo tóm tắt </el-button>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div @click="handleDownloadFullReport(info.slug)">
            <el-card :body-style="{ padding: '0px' }">
              <img src="@/assets/img/full_report.jpg" class="image padding-left-15 padding-right-15" />
              <div class="report_download_button">
                <el-button type="success" round>
                    <FAIcon icon="fas fa-file-download" /> Báo cáo chi tiết
                </el-button>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowReportDocumentForm = false">
            <FAIcon icon="fas fa-times margin-right-5" />Hủy bỏ
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiDownloadGroupDocumentAsArrayBuffer } from "@/services/document_management_service"
import { pushArraybuffer2Client } from "@/helpers/DownloadHelper"
import { DocumentState, DownloadType } from "@/constants/DoITConstant"
import FAIcon from "@/components/common/FAIcon.vue"

export default {
  name: "GroupDownloadReport",
  components: {},
  data: function () {
    return {
      isShowReportDocumentForm: false,
      fileList: [],
      FAIcon,
    }
  },
  props: ["info"],
  methods: {
    async handleDownloadSummaryReport(slug) {
      const loading = this.$loading({
        lock: true,
        text: "Đang tải tài liệu",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "l-spinner",
      })
      let res = await apiDownloadGroupDocumentAsArrayBuffer(slug, DownloadType.GENERAL_REPORT)
      // console.log(res)
      pushArraybuffer2Client(res, "summary_" + slug + ".pdf")

      loading.close()

      if (res == null) {
        this.$message({
          message: "Có lỗi xảy ra",
          type: "error",
        })
      }
    },
    async handleDownloadFullReport(slug) {
      const loading = this.$loading({
        lock: true,
        text: "Đang tải tài liệu",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "l-spinner",
      })
      let res = await apiDownloadGroupDocumentAsArrayBuffer(slug, DownloadType.HIGHLIGHT_REPORT)
      pushArraybuffer2Client(res, "full_" + slug + ".pdf")
      loading.close()

      if (res == null) {
        this.$message({
          message: "Có lỗi xảy ra",
          type: "error",
        })
      }
    },
    handleDownloadReport({ status }) {
      if (status) {
        if (status === DocumentState.DELETED) {
          this.$message({
            message: "Tài liệu đã bị xóa",
            type: "error",
          })
        } else if (status === DocumentState.ERROR) {
          this.$message({
            message: "Quá trình kiểm tra tài liệu xảy ra lỗi",
            type: "error",
          })
        } else if (status === DocumentState.COMPLETE_PROCESS) {
          this.isShowReportDocumentForm = true
        } else {
          this.$message({
            message: "Tài liệu chưa xử lý xong",
            type: "warning",
          })
        }
      }
    },
  },
  computed: {
    isDisable() {
      let { status } = this.info
      console.log(status)
      if (status) {
        if (status !== DocumentState.COMPLETE_PROCESS) {
          return "disable"
        }
        return ""
      }
      return "disable"
    },
  },
}
</script>

<style scoped>
.report_download_button {
  padding: 14px;
  text-align: center;
}

.checker-type-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}

.checker-type {
  width: 180px;
  margin-right: 10px;
}

.el-form-item__content .checker-type-container .el-input-group {
  margin: 0 0 8px 0;
  color: #8d9094;
  width: calc(100% - 180px - 10px);
  min-width: 260px;
}

label.el-form-item__label {
  font-size: 18px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.el-form-item__content .el-input-group {
  margin-top: 10px;
}

.icon {
  color: #0063fa;
  cursor: pointer;
}

.el-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

div.el-col.el-col-8 {
  margin: 0 5%;
}

div.el-col.el-col-8:hover {
  cursor: pointer;
}

.image {
  width: 100%;
  display: block;
  filter: grayscale(50%);
  -webkit-filter: grayscale(50%);
  -webkit-transition: all 0.5s ease;
}

.image:hover {
  filter: grayscale(10%);
  filter: gray;
  -webkit-filter: grayscale(10%);
  filter: none;
  transition: 0.5s ease;
}
</style>
